export default "__VITE_ASSET__BOk8ZkwN__"